import { PerTripDefinitionScoreConfig, SCORE_CONFIG_DEFAULTS, ScoreConfig } from '../interfaces/score-config.interface';

export function resolveScoreConfig(
    setting: PerTripDefinitionScoreConfig | undefined | null,
    tripDefinitionId: string | null | undefined,
): ScoreConfig {
    if (!Array.isArray(setting) || setting.length === 0 || !tripDefinitionId) {
        return SCORE_CONFIG_DEFAULTS;
    }

    const match = setting.find((item) => item.tripDefinition === tripDefinitionId);
    if (!match) return SCORE_CONFIG_DEFAULTS;

    return match.value;
}
